import { useEffect, useState } from "react";
import { PlusOutlined, HolderOutlined, DeleteOutlined } from "@ant-design/icons"
import { Button, Flex, Switch, Input } from "antd"
import { v4 as uuidv4 } from "uuid";
import DropdownInput from "./DropdownInput";
import { useTranslation } from 'react-i18next';

const mockData = [
    { id: uuidv4(), Object: 'API', Complexity: "medium", count: { "1": '4', "2": '1', "3": '1', "4": '2', "5": '1', "6": '1', "7": '1', "8": '1' }, timeline: "Week" }
]
const Object = (props) => {
    const { t } = useTranslation();
    const { sprintDetail, masterList, estimationData, updateEstimation } = props
    const [objects, setObjects] = useState(mockData)
    const [masterData, setMasterData] = useState({})
    const [objectMasterData, setObjectMasterData] = useState([])
    const [formFields, setFormFields] = useState([])
    const [costViewEnable, setCostViewEnable] = useState(false)

    useEffect(() => {
        if (estimationData.objects) {
            setObjects(estimationData.objects || [])
        }
    }, [estimationData.objects])

    const getObjectData = () => {
        let reqObjectData = masterList.find(data => data.dataName === "Object")
        setObjectMasterData(reqObjectData?.data || [])
        setMasterData(reqObjectData || {})
        setFormFields(reqObjectData?.fields || [])
    }

    useEffect(() => {
        if (masterList.length > 0) {
            getObjectData();
        }
    }, [masterList])

    const handleObjectChange = (object, key, value) => {
        let updatedObjects = objects.map(obj => {
            let reqObj = {...obj}
            if (obj.uuid === object.uuid) {
                reqObj[key] = value 
            } 
            if(reqObj.new){
                delete reqObj.new
            }
            return {...reqObj}
        })
        updateEstimation("objects", updatedObjects)
        // setObjects([...updatedObjects])
    }

    const addObject = () => {
        let durationData = {}
        for (let i = 1; i <= sprintDetail.duration; i++) {
            durationData[i] = ""
        }

        let updatedObjects = [...objects, { uuid: uuidv4(), new:true, "Object": "", "Complexity": "", count: { ...durationData } }]
        updateEstimation("objects", updatedObjects)

        // setObjects(updatedObjects)
    }

    const handleCountChange = (objId, currentDuration, value) => {
        let updatedObjects = [...objects];
        updatedObjects = updatedObjects.map(obj => {
            if (obj.id === objId) {
                return { ...obj, count: { ...obj.count, [currentDuration]: value } }
            } else {
                return { ...obj }
            }
        })
        updateEstimation("objects", updatedObjects)

        // setObjects(updatedObjects)
    }

    const deleteObject = (objId) => {
        let updatedObjects = objects.filter(object => object.id !== objId);
        updateEstimation("objects", updatedObjects)
        // setObjects(updatedObjects);
    }

    const handleEnableCost = (checked) => {
        setCostViewEnable(checked);
        let updatedObjects = [...estimationData.objects];
        if(checked){
            updatedObjects = updatedObjects.map(tool => {
                return {...tool, count: tool.calculatedEfforts}
            })
        } else {
            updatedObjects = updatedObjects.map(tool => {
                return {...tool, count: tool.count}
            })
        }
        setObjects(updatedObjects)
    }

    return (
        <>
            <Flex justify="space-between" align="center" style={{ padding: "0.75rem 2.5rem" }}>
                <div className="text-" style={{ color: "#000" }}>{t('Object')}</div>
            </Flex>
            <div className="sprint-container tool-container" style={{ minHeight: objects.length === 0 ? "23rem" : "fit-content" }}>
                <div className="sprint-header-row">
                    <div className="sprint-left-section">
                        <div className="add-sprint" style={{ justifyContent: "space-between", padding: "0 1rem 0 2.5rem" }}>
                            <span><Button className="submit-button" size="small" icon={<PlusOutlined />} style={{ marginRight: "8px" }} onClick={addObject} />{t('Add Object')}</span>
                            <span>{t('Cost View')} <Switch size="small" checked={costViewEnable} onChange={handleEnableCost} /></span>
                        </div>

                    </div>

                    <div className="sprint-right-section">
                        <div className="empty-block">{sprintDetail.timeline} </div>
                        <Flex>
                            {
                                [...Array(sprintDetail.duration)].map((e, i) => {
                                    return <div className="week-block" key={i} >
                                        <div className="week-cell" style={{ borderLeft: i === 0 ? "0px solid" : "1px solid #C7C8F3" }}>
                                            {Number(i + 1)}
                                        </div>
                                    </div>
                                })
                            }

                            <div className="week-block" style={{ flexGrow: "1", maxWidth: "none" }}>
                                <div className="week-cell" style={{ justifyContent: "flex-start", paddingLeft: "1rem", borderLeft: "1px solid #C7C8F3" }}>
                                </div>
                            </div>
                        </Flex>
                    </div>
                </div>

                {
                    objects.length > 0 && objects.map((object, index) => {
                        return (
                            <div className="sprint-row">
                                <div className="left-section-row-data">
                                    <div className="add-sprint-item" style={{ gap: 0 }}>
                                        <Flex gap={5} className="sprint-action">
                                            <HolderOutlined style={{ marginRight: "5px", visibility: "hidden" }} />
                                            <PlusOutlined style={{ visibility: "hidden" }} />
                                        </Flex>
                                        <div className={`object-input ${object.new ? "" : "tool-input"}`}>
                                            <DropdownInput data={object} masterData={objectMasterData} fieldLabel="Object" handleChange={handleObjectChange} parentValue="" />
                                            <DropdownInput data={object} masterData={objectMasterData} fieldLabel="Complexity" handleChange={handleObjectChange} parentValue="Object" />

                                            {/* <Input style={{ border: !object.title ? "1px solid #D9D9D9" : "" }} value={object.title} onChange={(e) => handleLabelChange(object.id, e.target.value)} /> */}
                                        </div>
                                        <DeleteOutlined className="app-icon delete-icon" onClick={() => deleteObject(object.id)} />
                                    </div>
                                </div>
                                <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                                    {
                                        [...Array(sprintDetail.duration)].map((e, i) => {
                                            // let currentDuration = sprintDetail.timeline + " " + Number(i + 1)
                                            let currentDuration = Number(i + 1)

                                            return <div className="week-block object-effort-block object-input" style={{ display: "flex", alignItems: "center" }}>
                                            {
                                                costViewEnable ? <div style={{width: "100%", textAlign: "center"}}>{object?.["count"]?.[currentDuration]}</div>
                                                :
                                                <Input readOnly={costViewEnable} value={object?.["count"]?.[currentDuration]} onChange={(e) => handleCountChange(object.id, String(currentDuration), Number(e.target.value))} style={{ textAlign: "center" }} />
                                            }

                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default Object